import axios from 'axios'
import util from '@/assets/js/util.js'
import { Notification } from 'element-ui'

const user = {
	state: {
		uid: '',
		name: '',
		face: '',
		grade: '',
		role: '',
		message: {},
		alertInfo: {},
		weekdataId: [0, 0],			// [跳转的 messageId，数据的 dataId]
		permission: {}, // 导航权限
		permissionSecond: {}, // 导航内页面模块权限
		permissionFunction: {}, // 其他权限
		guide: {},
		checkedUserInfo: false,		// 防止重复查询 userinfo
		openedWeekData: false,		// 防止重复弹出 周数据的 notification
		welcomeToast: false,
	},

  	mutations: {
		SET_UID: (state, uid) => {
			state.uid = uid
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_FACE: (state, face) => {
			state.face = face
		},
		SET_ROLE: (state, role) => {
			state.role = role
		},
		SET_GRADE: (state, grade) => {
			state.grade = grade
		},
		SET_MESSAGE: (state, data) => {
			state.message = data
		},
		SET_ALERT_INFO: (state, data) => {
			state.alertInfo = data
		},
		SET_WEEKDATAID: (state, ids) => {
			state.weekdataId = ids
		},
		SET_PERMISSION: (state, permission) => {
			state.permission = permission
		},
		SET_PERMISSION_SECOND: (state, permissionSecond) => {
			state.permissionSecond = permissionSecond
		},
		SET_PERMISSION_FUNCTION: (state, permissionFunction) => {
			state.permissionFunction = permissionFunction
		},
		SET_GUIDE: (state, guideObj) => {
			state.guide = guideObj
		},
		SET_WELCOMETOAST: (state, value) => {
			state.welcomeToast = value;
		},
		SWITCH_CHECKEDUSERINFO: (state, target) => {
			state.checkedUserInfo = target
		},
  	},

  	actions: {
		// 设置userInfos
		setUserInfos({ commit }, infos) {
			return new Promise((resolve, reject) => {
				for (let key in infos) {
					util.setCookie(key, infos[key], 20);
				}
				commit('SET_UID', infos.uid)
				commit('SET_NAME', infos.name)
				commit('SET_FACE', infos.face)
				commit('SET_GRADE', infos.grade)
				commit('SET_ROLE', infos.role)

				// 判断grade
				if (infos.grade == 1) {
					resolve()
				} else {
					this.dispatch('getUserInfo').then((res) => {
						resolve(res)
					}).catch(e => {
						console.log(e)
					})
				}
			})
		},

		// 查询用户是否是实习作者
		getUserInfo({ commit }, isRepeat) {
			return new Promise((resolve, reject) => {
				if (!this.state.user.checkedUserInfo || isRepeat) {
					commit('SWITCH_CHECKEDUSERINFO', true)
					axios({
						method: 'get',
						url: '/submit/user/info'
					}).then(res => {
						const data = res.data
						resolve(data)
					})
				} else {
					reject('repeat get user info')
				}
			})
		},

		// 查询用户权限permission
		checkPermission({ commit }) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'get',
					url: '/web/user/privilege_new',
					custom: true
				}).then(res => {
					if (res.code == 200) {
                        const permission = {}; // 导航权限
                        const permissionSecond = {}; // 页面内模块权限
                        const permissionFunction = res.data.function_privilege; // 其他权限

                        for (const key in res.data.navigation_privilege) {
                            if (key.includes('_sub_privilege')) {
                                permissionSecond[key.split('_sub_privilege')[0]] = res.data.navigation_privilege[key];
                            } else {
                                permission[key] = res.data.navigation_privilege[key];
                            }
                        }
						commit('SET_PERMISSION', permission);
						commit('SET_PERMISSION_SECOND', permissionSecond);
						commit('SET_PERMISSION_FUNCTION', permissionFunction);
                        commit('SET_GUIDE', {
                            newPracticer: permissionFunction.guide_newcomer,
                            neverFabTopic: permissionFunction.guide_publish_topic,
                            neverFabComic: permissionFunction.guide_publish_comic
                        })
						resolve(permission)
					} else {
						reject()
					}
				})
			})
		},

		// 查询每周数据汇总
		checkMessage({ commit }) {
			axios({
				method: 'get',
				url: '/submit/home_page/home_data',
				custom: true
			}).then(res => {
				if (res.code == 200) {
					let data = res.data
					// commit('SET_MESSAGE', data.unread_count)
					data = data.author_data
					if (data && data.update_status == 1) {
						const messageId = data.message_id
						const dataId = data.data_id
						const dataAry = [data.fav_count, data.like_count, data.comment_count, data.danmu_count]
						const textAry = ['人关注', '人点赞', '条评论', '个弹幕']
						let dataStr = []
						dataAry.forEach((item, index) => {
							if (item && item > 0) {
								dataStr.push(`${ item }${ textAry[index] }`)
							}
						})

						if (dataStr.length) {
							dataStr = dataStr.join('、')
							if (!this.state.user.weekdataId[0]) {
								Notification({
									message: `上周作品累计新增${ dataStr }，<a class="txt-detail" href="#/message/${ messageId }">查看详情</a>`,
									type: 'info',
									offset: 85,
									dangerouslyUseHTMLString: true,
									duration: 0
								})
							}
							commit('SET_WEEKDATAID', [messageId, dataId])
						} else {
							// 所有周数据都是0
							this.dispatch('clearMessageWeek', dataId)
						}
					}
				}
				// if (res.data) {
				// 	Notification.requestPermission().then(permission => {
				// 		console.log(permission)
				// 		let notification = new Notification('你有未读消息', {
				// 			body: '...'
				// 		})
				// 	})
				// }
			})
		},

		// 查询未读消息和每周数据汇总
		checkMessageUnread({ commit }) {
			axios({
				method: 'get',
				url: '/submit/home_page/notice_info',
				custom: true
			}).then(res => {
				if (res.code == 200) {
					let data = res.data
					commit('SET_MESSAGE', data)
				}
			})
		},
		// 查询弹窗提醒
		async checkAlert({ commit }) {
			let data;
			await axios({
				method: 'get',
				url: '/author/dialog/get',
				custom: true
			}).then(res => {
				if (res.code == 200) {
					data = res.data
					commit('SET_ALERT_INFO', data)
				}
			})
			return new Promise(resolve => {
				resolve(data);
			})
		},
		// 设置未读消息数量
		setMessageRead({ commit }, num) {
			commit('SET_MESSAGE', num)
		},

		// 每周数据已读
		clearMessageWeek({ commit }, dataId) {
			commit('SET_WEEKDATAID', [0, dataId])
			Notification.closeAll()
			axios({
				method: 'post',
				url: '/submit/home_page/read_data',
				data: {
					data_id: dataId
				}
			})
		},

		// 退出登录
		logOut({ commit }) {
			return new Promise((resolve) => {
				commit('SWITCH_CHECKEDUSERINFO', false)

				const clearVueX = () => {
					const userId = this.state.user.uid
					if (userId) {
						commit('SET_UID', '')
						commit('SET_NAME', '')
						commit('SET_FACE', '')
						commit('SET_GRADE', '')
						commit('SET_PERMISSION', [])
					}

					util.delCookie('passToken')
					util.delCookie('name')
					resolve()
				}

				if (this.state.app.environment == 'local') {
					clearVueX.call(this)
				} else {
					axios({
						method: 'post',
						url: '/v1/passport/login/pc/user_log_out'
					}).then(() => {
						clearVueX.call(this)
					})
				}
			})
		},

		// 设置某项权限
		setGuideItem({ commit }, item) {
			let guides = this.state.user.guide
			if (guides[item]) {
				guides[item] = false
			}
			commit('SET_GUIDE', guides)
		},

		// checkedUserInfo初始化（置为false，目前在applyauthor页面会调用）
		initCheckedUserInfo({ commit }) {
			commit('SWITCH_CHECKEDUSERINFO', false)
		}
	}
}

export default user
